const DEFAULT_KEY = '45172fe5-cca5-422c-bf36-a727651c1e56'
const PAYPAL_CLIENT_ID = "Ad077-Gx8stGcfWQYawBiQUc4UbKWIRIg_PK4lHL4pzHR-uOPMz2vCk_jQ8QU9pcEw0j8U3UYDrEUS75"

// const BASE_URL = "http://192.168.21.19:5075/node_api/";//local
// const BASE_URL = "https://joy.admin.iossmlm.com/node_api/";//demo
// const BASE_URL = "http://67.225.139.56:5000/node_api/" //live
const BASE_URL = "https://admin.healthprousa.com/node_api/" //live


export { BASE_URL, DEFAULT_KEY, PAYPAL_CLIENT_ID }